<template>
  <div>
    <section>
      <h4><span v-html="d_modal_contract?'选择合同':'已选合同'"></span>
        <Icon type="md-create" size="20" @click="d_modal_contract=!d_modal_contract"/>
      </h4>
      <contract-t v-if="d_modal_contract" @selectContract="getSelectContract"></contract-t>
      <div v-if="!d_modal_contract">
        <div v-if="d_select_contract.SerialNum">合同编号：{{ d_select_contract.SerialNum }} &nbsp; &nbsp; &nbsp; 合同名称：{{d_select_contract.Name}}</div>
        <div v-else>您没有选择合同，请选择</div>
      </div>
    </section>
    <section v-if="d_select_contract.SerialNum">
      <h4><span v-html="d_modal_pay?'选择费用':'已选费用'"></span>
        <Icon type="md-create" size="20" @click="d_modal_pay=!d_modal_pay"/>
      </h4>
      <pay-t v-if="d_modal_pay" :ContractID="d_select_contract.SerialNum" @selectPay="getSelectPay"></pay-t>
      <div v-if="!d_modal_pay">
        <div v-if="d_select_pay.ID">
          <Row>
            <Col span="12">费用编号：{{ d_select_pay.ID }}</Col>
            <Col span="12">付款方式：{{ d_select_pay.PayWayType }}</Col>
            <Col span="12">收款类型：{{ d_select_pay.NormalType }}</Col>
            <Col span="12">收退款：{{ d_select_pay.ShouTuiType }}</Col>
            <Col span="12">小项：{{ d_select_pay.XiaoXiang }}</Col>
            <Col span="12">税率：{{ d_select_pay.TaxRate }}%</Col>
            <Col span="12">单项金额：{{ d_select_pay.Money }}元</Col>
            <Col span="12">余额：{{ d_select_pay.Yue }}元</Col>
            <Col span="12">负责人：{{ d_select_pay.Agent }}</Col>
          </Row>
        </div>
        <p v-else>您没有选择任何费用</p>
      </div>
    </section>
    <section v-if="d_select_contract.SerialNum && d_select_pay.ID">
       <h4>合同缴费<Button type="primary" @click="to_payMore" class="absolute-right">批量缴纳</Button></h4>
      <Table :loading="loading"
             ref="selection"
             border
             :columns="d_columns"
             height="495"
             :data="d_data"
             @on-selection-change="get_select_data"></Table>
      <div class="pay-group">
        <span>已选债务合计：{{ bill_total(d_billPay_checked,2) }} 元</span>
      </div>
    </section>
    <section v-if="!d_modal_contract && !d_modal_pay">
      <h4>缴费记录</h4>
      <bill-t :ContractID="d_select_contract.SerialNum" :billIsRefresh="bill_isRefresh"></bill-t>
    </section>
  </div>
</template>
<script>
  import apiBill from '@/api/bill.js';
  import apiSystem from '@/api/system.js';
  import contractT from './table/contractT';
  import payT from './table/payT';
  import billT from './table/billT';
  let moment = require('moment');
  export default {
    name:'costManage_page',
    data() {
      return {
        loading:false,
        d_billPay_checked:[],
        bill_isRefresh:true,
        d_columns:[
          {
            type: 'selection',
            width: 60,
            align: 'center',
            fixed: 'left'
          },
          {
            title: '时间',
            key: 'BeginDate',
            width:100
          },
          {
            title: '是否缴纳',
            key: 'State'
          },
          {
            title: '租金类型',
            key: 'XiaoXiang'
          },
          {
            title: '欠债',
            key: 'Debts',
            render: (h, params) => {
              return h('span',params.row.Debts+' 元')
            }
          },
          {
            title: '金额',
            key: 'Money',
            render: (h, params) => {
              return h('span',params.row.Money+' 元')
            }
          }
        ],
        d_data:[],
        d_rate_list:[],
        d_modal_contract: true,
        d_modal_pay:true,
        d_select_contract:{},
        d_select_pay:{}
      }
    },
    components:{
      contractT,
      payT,
      billT
    },
    watch:{
      d_select_pay: {
        handler(newValue, oldValue) {
          this.pull_data();
        },
        deep: true
      }
    },
    methods: {
      to_date(date){
        return moment(date).format('YYYY-MM-DD');
      },
      getSelectContract(row){
        this.d_select_contract = row;
        this.d_modal_contract = false;
        this.d_modal_pay = true;
      },
      getSelectPay(row){
        this.d_select_pay = row;
        this.d_modal_pay = false;
      },
      bill_total(row,moneyType){
//参数moneyType，不传总计money,传总计债务
        let TotalMoney = 0;
        for (const item of row) {
          if(moneyType){
            TotalMoney = TotalMoney+item.Debts;
          }else {
            TotalMoney = TotalMoney+item.Money;
          }
        }
        return TotalMoney.toFixed(2);
      },
      pull_Rate_data(){
        apiSystem.getList.post().then((_data) => {
          if(_data.data.ExeSuccess && _data.data.LoginSuccess){ //登录成功+执行成功
            let rowsList =  _data.data.Data.RowsList;
            for(let i=0;i<rowsList.length;i++){
              if(rowsList[i].Name === 'TaxRate'){
                let arrValue = rowsList[i].Value.split(',');
                arrValue = arrValue.map(item=>{
                  return {
                    value: item,
                    label: item
                  }
                })
                this.d_rate_list = arrValue;
              }
            }
          }else {
            this.$Message.error(_data.data.Msg);
          }
        });
      },
      pull_data(){
        if(!this.d_select_contract.SerialNum){
          this.$Message.error('请选择合同id');
          return;
        }
        let params = {
          PageIndex: 1,
          PageSize: 999,
          Orderby:'1', // 账单缴费列表升序
          CondList: [
            {
              Key: 'b.ContractID',
              Operator: "=",
              Value: this.d_select_contract.SerialNum
            },
            {
              Key: 'b.XiaoXiang',
              Operator: "=",
              Value: this.d_select_pay.XiaoXiang
            },
            {
              Key: 'b.Debts',
              Operator: ">",
              Value: 0
            }
          ]
        };
        apiBill.getList.post(params).then((_data) => {
          if(_data.data.ExeSuccess && _data.data.LoginSuccess){
            let rowsList = _data.data.Data.RowsList;
            this.d_data = rowsList.filter(item=>item.State!=='已结清');
            // this.d_data = rowsList.sort(function(a,b){
            //   let dateA = new Date(a.BeginDate).getTime();
            //   let dateB = new Date(b.BeginDate).getTime();
            //   return dateA - dateB
            // })
          }else {
            this.$Message.error(_data.data.Msg);
          }
        });
      },
      get_select_data(row){
        this.d_billPay_checked = row;
      },
      to_payMore(){
        this.submit_data(); //批量支付
      },
      submit_data(){ //用于缴费
        let billListArr = this.d_billPay_checked.map(item=>item.ID)
        let _this = this;
        let params = {
          BillIdList: billListArr,
          PayID: this.d_select_pay.ID,
          PayDay: this.to_date(new Date()),
        }
        apiBill.pay.post(params).then((_data) => {
          if(_data.data.ExeSuccess && _data.data.LoginSuccess){
            _this.$Message.success(_data.data.Data);
            this.pull_data();
            this.bill_isRefresh = !this.bill_isRefresh ;//重新加载bill数据
            let paidMoney = this.bill_total(this.d_billPay_checked,2)+'';//已经交过的钱
            this.d_select_pay.Yue = Number(this.d_select_pay.Yue)-Number(paidMoney);
            if(this.d_select_pay.Yue<=0){
              this.$Message.warning('您选择的当前费用余额已经没有了，建议切换费用，系统将自动为您清空已选择费用');
              this.d_select_pay = {}
            }else if(this.d_select_pay.Yue<=100){
              this.$Message.warning('温馨提示，费用余额不足100元');
            }
            this.d_billPay_checked=[];

          }else {
            _this.$Message.error(_data.data.Msg);
          }
        });
      },
    },

    created() {
      this.pull_Rate_data();//获取所有税率
      let contractInfo = sessionStorage.getItem('contractInfo'); //存在合同的话就根据合同拉数据
      if(contractInfo){
        this.d_select_contract = JSON.parse(contractInfo);
        this.d_modal_contract = false;
      }
    }
  }
</script>
<style lang="less" scoped>
  @import "../../../assets/css/table-list.css";
  .form-title{ line-height: 40px;text-indent: 10px;background-color: #f3f3f3;margin-bottom: 10px; }
  .margin-right10{ margin-right: 10px; }
  .cost-form-group{ border:solid 1px #e8eaec;padding:20px 0; }
  .marginL100{ margin-left: 5%; }
  .t-table{
    width: 100%;
    border-collapse: collapse;
    border-spacing: 0;
    td, th {
      word-break: break-all;
      word-wrap: break-word;
      border: none;
      padding: 10px 0;
      text-align: center;
      width: 25%;
      font-weight: normal;
      position: relative;
      .ivu-icon{
        font-size: 20px;
      }
    }
  }
  section{
    margin-top: 40px;
    margin-bottom: 20px;
    h4{
      position: relative;
      line-height: 24px;
      margin-bottom: 10px;
      font-size: 15px;
      text-indent: 10px;
      &:before{
        content: '';
        position: absolute;
        left: 0;
        width: 4px;
        top:0;
        height: 100%;
        background-color: #2d8cf0;
      }
    }
    h5{
      font-size: 14px;
      line-height: 32px;
      padding:5px 0;
      font-weight: normal;
      color:#5c5c5c;

    }
    .pay-group{
      border:solid 1px #dcdee2;
      border-top:none;
      text-align: right;
      padding:10px 0;
      Button{
        margin-right: 10px;
      }
      span{ margin-right: 10px; }
    }
  }
  .ivu-checkbox-wrapper{ margin-right: 0 }
  .p-div p{ display: inline-block;width: 200px; }
  .absolute-right{
    position: absolute;
    right:0;
    bottom:10px;
  }
  h5{ position: relative; }
</style>
<style>
  .no-padding-card .ivu-card-body{ padding: 0; }
  .ivu-form-item-content{ line-height: 33px; }
</style>
